import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Grid,
  Box,
  TextField,
  Typography,
  Divider,
} from "@mui/material";
import { useSnackbar } from "components/GlobalSnackbar";
import { apiGetAllZones } from "api/zones";
import { buttonStyles } from "utils/buttonStyles";
import { dialogHeaderStyles, dialogContentStyles } from "utils/dialogStyles";

function TambahZon({ open, onClose, onSave }) {
  const { showError } = useSnackbar();
  const [formState, setFormState] = useState({
    zon: "",
    bahagian_pemantau: "",
  });

  // Autofill bahagian_pemantau from logged-in user (use user.bahagian)
  useEffect(() => {
    if (open) {
      const user = JSON.parse(localStorage.getItem("user") || "{}");
      setFormState((f) => ({ ...f, bahagian_pemantau: user.bahagian || "" }));
    }
  }, [open]);

  // Reset form when dialog closes
  useEffect(() => {
    if (!open) {
      setFormState({
        zon: "",
        bahagian_pemantau: "",
      });
    }
  }, [open]);

  const handleChange = (e) => {
    setFormState({ ...formState, [e.target.name]: e.target.value });
  };

  const handleSave = async () => {
    // Validate required fields
    if (!formState.zon || formState.zon.trim() === "") {
      alert("Sila masukkan nama zon yang diperlukan.");
      return;
    }
    if (!formState.bahagian_pemantau || formState.bahagian_pemantau.trim() === "") {
      alert("Bahagian Pemantau diperlukan.");
      return;
    }
    try {
      if (onSave) await onSave(formState);
      onClose();
    } catch (error) {
      alert("Ralat semasa menyimpan zon. Sila cuba lagi.");
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle sx={dialogHeaderStyles.info}>
        <Box display="flex" alignItems="center" justifyContent="space-between">
          <Typography variant="h6" sx={{ color: "#fff" }}>Tambah Zon</Typography>
        </Box>
      </DialogTitle>
      <DialogContent dividers sx={dialogContentStyles.light}>
        {/* Maklumat Nama & Bahagian Pemantau */}
        <Grid container spacing={2}>
          <Grid item xs={12} md={12}>
            <TextField
              label="Zon"
              name="zon"
              value={formState.zon}
              onChange={handleChange}
              required
              fullWidth
              margin="dense"
            />
          </Grid>
          <Grid item xs={12} md={12}>
            <TextField
              label="Bahagian Pemantau"
              name="bahagian_pemantau"
              value={formState.bahagian_pemantau}
              InputProps={{ readOnly: true }}
              required
              fullWidth
              margin="dense"
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions sx={dialogContentStyles.light}>
        <Button
          variant="contained"
          onClick={handleSave}
          size="small"
          sx={{
            ...buttonStyles.save,
            m: 0,
            px: 2,
            minWidth: 0
          }}
        >
          SIMPAN
        </Button>
        <Button
          variant="contained"
          onClick={onClose}
          size="small"
          sx={{
            ...buttonStyles.cancel,
            m: 0,
            px: 2,
            minWidth: 0
          }}
        >
          BATAL
        </Button>
      </DialogActions>
    </Dialog>
  );
}

TambahZon.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
};

export default TambahZon;
